import { useQueryClient } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { toast } from 'sonner'

import {
    type ErrorStruct,
    getRecruitmentQueryKey,
    getUserRequestsByExternalIdWatchdocsUserRequestIdQueryKey,
    usePostUserRequestsIdSubmit,
} from '@/shared/api'
import { PAGE_SIZE } from '@/shared/model'

export const useRequestSendForReview = (requestPublicId: string) => {
    const queryClient = useQueryClient()
    const navigate = useNavigate()

    const { mutateAsync: sendForReview, isPending } = usePostUserRequestsIdSubmit({
        mutation: {
            onSuccess: async () => {
                await queryClient.invalidateQueries({
                    queryKey:
                        getUserRequestsByExternalIdWatchdocsUserRequestIdQueryKey(requestPublicId),
                })

                await queryClient.invalidateQueries({
                    queryKey: getRecruitmentQueryKey({
                        limit: PAGE_SIZE,
                        offset: 0,
                    }),
                })

                toast.success(`Заявка №${requestPublicId} отправлена на проверку`)
                navigate({ to: '/requests/$id', params: { id: requestPublicId } })
            },
            onError: (error) => {
                const { error_message } = error as ErrorStruct
                toast.error(`Не удалось отправить заявку №${requestPublicId}: ${error_message}`)
                throw error
            },
        },
    })

    return {
        sendForReview,
        isPending,
    }
}
